<template>
  <div class="person-list">
    <el-table
      v-loading="loading"
      v-el-table-height-fix
      :data="tableData"
      height="300px"
    >
      <el-table-column prop="fName" label="区域负责人" />
      <el-table-column prop="fMobilePhone" label="负责人电话" />
      <el-table-column prop="fEmail" label="负责人邮箱" />
    </el-table>
  </div>
</template>

<script>
import md5 from 'md5'

export default {
  data: function() {
    return {
      tableData: [],
      loading: true
    }
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const userNumber = this.$store.state.userNumber
          const data = Object.assign({}, this.form)
          //  console.log(userNumber)
          //  console.log(userNumber['userNumber'])
          data['oldPassword'] = md5(
            userNumber['userNumber'] +
              data['oldPassword'] +
              userNumber['userNumber']
          ).toUpperCase()
          data['newPassword'] = md5(
            userNumber['userNumber'] +
              data['newPassword'] +
              userNumber['userNumber']
          ).toUpperCase()
          delete data['newPassword2']

          onValid(data)
        } else {
          return false
        }
      })
    },
    getTableData() {
      this.loading = true
      this.$httpPost('GetRegionForDirectorEntry', {})
        .then((res) => {
          this.tableData = res.datalist
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.person-list {
  height: 100%;
}
</style>
